import { render } from "./Reperibilita.vue?vue&type=template&id=bef60e72&scoped=true"
import script from "./Reperibilita.vue?vue&type=script&lang=js"
export * from "./Reperibilita.vue?vue&type=script&lang=js"

import "./Reperibilita.vue?vue&type=style&index=0&id=bef60e72&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_plan_1778832654194047890/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef60e72"]])

export default __exports__